module.exports = __webpack_public_path__ + "img/pr-7.1aa66248.png";